import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'pixie-story-link-item',
  templateUrl: './story-link-item.component.html',
  styleUrls: ['./story-link-item.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class StoryLinkItemComponent {

  @Input() linkItem;

}
